// Which Needs you items the practitioner has opened. An item never opened is "new" (blue dot, soft tint); once opened
// it goes quiet. Kept for the browser session only (sessionStorage), so coming back from an encounter does not make
// every item new again. This is UI state, not data: the wire carries no read marker for a draft note.
import { useCallback, useState } from 'react';

export const SEEN_NEEDS_KEY = 'ready-list-seen-needs';
const KEY = SEEN_NEEDS_KEY;

function load(): ReadonlySet<string> {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    const ids: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(ids) ? ids.filter((x): x is string => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

export function useSeenNeeds(): { seen: ReadonlySet<string>; markSeen: (id: string) => void } {
  const [seen, setSeen] = useState<ReadonlySet<string>>(load);
  const markSeen = useCallback((id: string) => {
    setSeen((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev).add(id);
      try {
        window.sessionStorage.setItem(KEY, JSON.stringify([...next]));
      } catch {
        // storage blocked: the marker lives for this mount only
      }
      return next;
    });
  }, []);
  return { seen, markSeen };
}
